import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  IpoLanguageService,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { Language } from '../../../../shared/language-chooser/language-chooser-entities';
import { DeliveryReportPdfService } from '../../../../shared/pdf-tools/pdf-report/delivery-report-pdf.service';
import { RolloutProgressReportEntities } from '../../../../shared/self-inspection-reports/service/entities';
import { ToastsService } from '../../../../shared/toast/toast.service';
import { DistributionPointProperties } from '../../../span-progress-entities';
import { PopupPdfDownloadController } from '../popup-pdf-download.controller';
import { createReportablePopupPdfContext } from '../popup-report.utils';
import {
  cancelPdfDownloadOnPointChange,
  pointIdIdentityChanged,
  POPUP_PDF_DOWNLOAD_TOOLTIP,
  openReportInNewTab,
} from '../popup-pdf.utils';

@Component({
  selector: 'app-reportable-point-popup-content',
  templateUrl: './reportable-point-popup-content.component.html',
  styleUrl: './reportable-point-popup-content.component.scss',
  standalone: false,
})
export class ReportablePointPopupContentComponent
  implements OnChanges, OnDestroy
{
  @Input() properties: DistributionPointProperties;
  @Input() status: string;
  @Input() markerType: RolloutProgressReportEntities.v3.MarkerTypes;
  @Output() dismiss = new EventEmitter();

  downloadTooltipLabel = POPUP_PDF_DOWNLOAD_TOOLTIP;
  pdfController: PopupPdfDownloadController;

  private destroyed = false;

  constructor(
    private readonly router: Router,
    private readonly pdfService: DeliveryReportPdfService,
    private readonly languageService: IpoLanguageService,
    private readonly toastsService: ToastsService,
    private readonly translate: IpoTranslatePipe,
  ) {
    this.pdfController = new PopupPdfDownloadController(
      pdfService,
      toastsService,
      translate,
      createReportablePopupPdfContext(
        () => this.router.url,
        () => this.properties.id,
        () => this.properties.name ?? '-',
        () => (this.languageService.getStoredLanguage() as Language) ?? 'en',
        () => this.markerType,
        () => this.destroyed,
      ),
    );
  }

  ngOnChanges(changes?: SimpleChanges): void {
    cancelPdfDownloadOnPointChange(changes, pointIdIdentityChanged, () =>
      this.pdfController.cleanup(),
    );
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.pdfController.cleanup();
  }

  onClosePopup() {
    this.dismiss.emit();
  }

  openReport(): void {
    openReportInNewTab(this.router.url, this.markerType, this.properties.id);
  }

  onDownloadPreviewPdf(event: MouseEvent): void {
    this.pdfController.onDownloadPreviewPdf(event);
  }

  onDownloadPreviewPdfKeyDown(event: KeyboardEvent): void {
    this.pdfController.onDownloadPreviewPdfKeyDown(event);
  }
}
